import React, { useState } from 'react';
import { useSwitchChain } from 'wagmi';
import { base } from 'wagmi/chains';
import { ReactComponent as NetworkIcon } from '../assets/svg/network_icon.svg';
import { ReactComponent as CloseIcon } from '../assets/svg/banner_close_icon.svg';

interface ChainNotificationBannerProps {
  isSwitching?: boolean;
  onClose?: () => void;
}

const ChainNotificationBanner: React.FC<ChainNotificationBannerProps> = ({
  isSwitching = false,
  onClose,
}) => {
  const { switchChain } = useSwitchChain();
  const [isVisible, setIsVisible] = useState(true);

  const handleSwitchToBase = () => {
    if (switchChain) {
      switchChain({ chainId: base.id });
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 w-full h-9 md:h-10 bg-primary-azul">
      <div className="h-full flex items-center justify-between px-4 md:px-8">
        {/* Left side - Icon and text */}
        <div className="flex items-center gap-2">
          <NetworkIcon className="w-5 h-5 text-contrast-7" />
          <span className="text-white text-[14px] font-medium font-inter">
            Switch Network to Base
          </span>
          <span className="text-[#B1CAFF] text-[14px] font-normal font-inter hidden md:inline">
            please switch your wallet to the Base Network in order to use this $VLR claiming tool
          </span>
        </div>

        {/* Right side - Button and close icon */}
        <div className="flex items-center gap-3">
          {isSwitching ? (
            <span className="text-white/70 text-[12px] font-medium font-inter uppercase px-2 py-1.5">
              SWITCHING...
            </span>
          ) : (
            <button
              onClick={handleSwitchToBase}
              className="bg-white hover:bg-white/90 text-primary-azul px-2 py-1.5 rounded-[6px] text-[12px] font-medium font-inter uppercase transition-colors h-6 flex items-center"
            >
              <span className="md:hidden">SWITCH</span>
              <span className="hidden md:inline">SWITCH NETWORK</span>
            </button>
          )}
          <button
            onClick={handleClose}
            className="w-[23px] h-[23px] flex items-center justify-center hover:opacity-80 transition-opacity"
            aria-label="Close banner"
          >
            <CloseIcon className="w-full h-full" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChainNotificationBanner;
